export default "__VITE_ASSET__CfdMQ4VP__"